import { BenefitsBenefitAvailabilityFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type PerkId = 'santander_free_iphone'

export interface PerkItem {
  id: PerkId
  title: string
  description: string
  emoji: string
  externalUrl?: string
}

function isPerksAvailable(featureAvailabilities?: BenefitsBenefitAvailabilityFragment[]) {
  return (
    featureAvailabilities?.find((feature) => feature.id === 'benefits_perks')?.available ?? false
  )
}

export const getAvailablePerks = (
  featureAvailabilities?: BenefitsBenefitAvailabilityFragment[]
): PerkItem[] => {
  const perksAvailable = isPerksAvailable(featureAvailabilities)

  if (!perksAvailable) {
    return []
  }

  return [
    {
      id: 'santander_free_iphone',
      title: i18n.t('benefits.perks.santander_free_iphone.title'),
      description: i18n.t('benefits.perks.santander_free_iphone.description'),
      emoji: '📱',
      externalUrl:
        'https://www.bancosantander.es/particulares/cuentas-tarjetas/cuentas-corrientes/cuenta-online-iphone',
    },
  ]
}
